export default "__VITE_ASSET__NEPcWJBT$kZEeeg6IT4dYw__"